module.exports = __webpack_public_path__ + "static/img/24.851677b.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/ProcessAutomation/24.png
// module id = LCWu
// module chunks = 1